// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"f7804b59","384":"73bab9b5","485":"3807a137","732":"0d116b20","859":"430df6e6","961":"1fdf3511"}[chunkId] + ".chunk.js";
};